var React = require('react');

function SnellIconCheckbox (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".snell-ico-checkbox-a{fill:#fff;}.snell-ico-checkbox-b,.snell-ico-checkbox-c{stroke:none;}.snell-ico-checkbox-c{fill:#7d858b;}")),React.createElement("g",{"className":"snell-ico-checkbox-a","transform":"translate(-15143 485)","key":1},[React.createElement("path",{"className":"snell-ico-checkbox-b","d":"M 29.5 29.5 L 0.5 29.5 L 0.5 0.5 L 29.5 0.5 L 29.5 29.5 Z","key":0}),React.createElement("path",{"className":"snell-ico-checkbox-c","d":"M 29 29 L 29 1 L 1 1 L 1 29 L 29 29 M 30 30 L -1.77635683940025e-15 30 L -1.77635683940025e-15 -1.77635683940025e-15 L 30 -1.77635683940025e-15 L 30 30 Z","key":1})])]);
}

SnellIconCheckbox.defaultProps = {"viewBox":"-15143 485 30 30"};

module.exports = SnellIconCheckbox;

SnellIconCheckbox.default = SnellIconCheckbox;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js?name=SnellIconCheckbox!./src/assets/images/icon_checkbox.svg
// module id = 868
// module chunks = 1